import script from "./editAccountInfoModal.vue?vue&type=script&setup=true&lang=js"
export * from "./editAccountInfoModal.vue?vue&type=script&setup=true&lang=js"

import "./editAccountInfoModal.vue?vue&type=style&index=0&id=2f19f018&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f19f018"]])

export default __exports__